import { render, staticRenderFns } from "./driver-pickup-statistic.vue?vue&type=template&id=94d2a70a&scoped=true&"
import script from "./driver-pickup-statistic.vue?vue&type=script&lang=js&"
export * from "./driver-pickup-statistic.vue?vue&type=script&lang=js&"
import style0 from "./driver-pickup-statistic.vue?vue&type=style&index=0&id=94d2a70a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d2a70a",
  null
  
)

export default component.exports